import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { ProviderPayablesScheduleView } from '../../features/salesOrder/components/ProviderPayablesScheduleView';
import { ProviderPaymentsNav } from './ProviderPaymentsNav';

export const ProviderPaymentsSchedulePage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container spacing={2} sx={{ p: 3 }}>
				<Grid item xs={12}>
					<Typography variant="h4" gutterBottom>
						Pagos a Proveedores
					</Typography>
					<ProviderPaymentsNav />
					<Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
						Líneas agrupadas por fecha de vencimiento programado según la regla de pago del proveedor.
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<ProviderPayablesScheduleView />
				</Grid>
			</Grid>
		</Layout>
	);
};
